import React, { useState } from 'react';
import type { Nullable, StringMap } from 'corgi-types';

import AutoScrollAlert from 'common/components/AutoScrollAlert';
import type { MessageType } from 'common/enums/Alert';
import { EventBusEvent } from 'common/enums/EventBus';
import { useSubscriptionCallback } from 'common/hooks/subscription';
import { useLocalization } from 'common/providers/LocaleProvider';
import type { AlertProps } from '../../edit-profile-form/components/shared/types';

interface AlertComponentProps {
  alertType?: MessageType;
  alertMessage?: string;
  alertTranslationProps?: StringMap<string | number>;
}

const formatAlert = (alert: Nullable<AlertProps>) => {
  return alert && alert.message
    ? {
        ...alert,
        timestamp: Date.now(),
      }
    : null;
};

const useAlert = (initialAlert: AlertComponentProps) => {
  const { r } = useLocalization();

  const [alert, setAlert] = useState(() =>
    formatAlert({
      message:
        initialAlert.alertMessage &&
        r.t(initialAlert.alertMessage, initialAlert.alertTranslationProps),
      type: initialAlert.alertType,
    })
  );

  useSubscriptionCallback<Nullable<AlertProps>>(EventBusEvent.MyProfileAlert, alertEvent =>
    setAlert(formatAlert(alertEvent))
  );

  return alert;
};

const MyProfileHeaderAlert = (initialAlert: AlertComponentProps) => {
  const alert = useAlert(initialAlert);
  if (!alert) return null;

  const { message, timestamp, type } = alert;

  return (
    <AutoScrollAlert
      scrollOnError
      message={message}
      messageId={timestamp}
      type={type}
      mt="sp_8"
      mb="sp_16"
    />
  );
};

export default MyProfileHeaderAlert;
